export enum DirectionEnum {
  Asc = 'asc',
  Desc = 'desc',
  None = 'none'
}
